export function toNumericValue(value: unknown): number | undefined {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? undefined : numericValue;
}

export function formatPresetLabel(preset: number, suffix?: string): string {
  return `${preset}${(suffix ?? '').trim()}`;
}

export function isCustomPresetValue(
  value: number | undefined,
  presets: number[]
): boolean {
  return value !== undefined && !presets.includes(value);
}
